<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("Security") }}</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>
    <div class="container-center lg animated fadeIn">
      <nav id="nav">
        <ul class="nav">
          <li>
            <router-link to="/changepassword">
              <i class="fad fa-unlock-alt"></i>
              {{ $t("Changepassword") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
          <li>
            <router-link to="/googleauthen">
              <i class="fad fa-shield-alt"></i>
              {{ $t("GoogleAuthentication") }}

              <span class="nav-icon">
                <span v-if="getSecure.google_authen_active">
                  {{ $t("ON") }}
                </span>
                <span v-else>
                  {{ $t("OFF") }}
                </span>
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
          <li class="hidden">
            <router-link to="/mailconfirm">
              <i class="fad fa-clipboard-check"></i>
              {{ $t("WithdrawalVerificationEmails") }}

              <span class="nav-icon">
                <span v-if="getSecure.mail_confirm">
                  {{ $t("ON") }}
                </span>
                <span v-else>
                  {{ $t("OFF") }}
                </span>
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
          <li>
            <router-link to="/logs">
              <i class="fad fa-tablet-alt"></i>
              {{ $t("DeviceManagement") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: mapGetters(["getSecure"]),
  methods: {
    ...mapActions(["Logout"]),
  },
};
</script>

<style scoped>
.nav a {
  color: #949ba2;
  background: #1d1f24;
  margin-bottom: 5px;
}
.nav > li > a:focus,
.nav > li > a:hover {
  text-decoration: none;
  background-color: #2c313c;
}
.nav {
  margin-bottom: 10px;
}
.nav-icon {
  float: right;
}
.fad {
  width: 22px;
}
</style>
